import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardActions from "@mui/material/CardActions";
import Button from "../Button";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import HelpIcon from "@mui/icons-material/Help";
import ArticleIcon from "@mui/icons-material/Article";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { borderRadius, fontWeight, margin } from "@mui/system";

export const AssessmentCard = ({ assessment, cardActions }) => {
  const {
    assessmentId,
    status,
    courseCode,
    type,
    timeAllowed,
    noOfQuestions,
    totalMarks,
    passGrade,
    createdDate,
    createdUserName,
  } = assessment;

  return (
    <Card
      sx={{
        width: "48%",
        mr: "2%",
        background: "var(--mui-palette-background-level1)",
        boxShadow: "0 5px 10px rgba(0, 0, 0, 0.1)",
        position: "relative",
        pb: "15px",
      }}
    >
      <CardContent>
        <Typography
          gutterBottom
          color="primary.blue"
          variant="h5"
          sx={{ fontWeight: "600", fontSize: "18px", mb: "20px" }}
        >
          {courseCode} - {type}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            position: "absolute",
            right: "10px",
            top: "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {status === "Active" ? (
            <ToggleOnIcon
              sx={{
                mr: 0.5,
                color: "var(--mui-palette-primary-orange)",
                fontSize: "34px",
              }}
              titleAccess={status}
            />
          ) : (
            <ToggleOffIcon
              sx={{
                mr: 0.5,
                color: "var(--mui-palette-primary-darkGrey)",
                fontSize: "34px",
              }}
              titleAccess={status}
            />
          )}
          {/* {status} */}
        </Typography>
        <Typography
          sx={styles.questionItemLarge}
          variant="body2"
          color="text.secondary"
        >
          <CalendarMonthIcon
            sx={styles.questionItemIcon}
            titleAccess="Created Date"
          />
          <span style={styles.questionItemValue}>
            {new Date(createdDate).toLocaleDateString()}
          </span>{" "}
          {/* <span style={styles.questionItemLabel}>Created Date</span> */}
        </Typography>
        <Typography
          sx={styles.questionItemLarge}
          variant="body2"
          color="text.secondary"
        >
          <AccountCircleIcon
            sx={styles.questionItemIcon}
            titleAccess="Created By"
          />
          <span style={styles.questionItemValue}>{createdUserName}</span>{" "}
          {/* <span style={styles.questionItemLabel}>Created By</span> */}
        </Typography>
        <Typography
          sx={styles.questionItem}
          variant="body2"
          color="text.secondary"
        >
          <AccessTimeFilledIcon
            sx={styles.questionItemIcon}
            titleAccess="Time Allowed"
          />
          <span style={styles.questionItemValue}>{timeAllowed}</span>{" "}
          <span style={styles.questionItemLabel}>Minutes</span>
        </Typography>
        <Typography
          sx={styles.questionItem}
          variant="body2"
          color="text.secondary"
        >
          <HelpIcon
            sx={styles.questionItemIcon}
            titleAccess="Number of Questions"
          />
          <span style={styles.questionItemValue}>{noOfQuestions}</span>{" "}
          <span style={styles.questionItemLabel}>No. Questions</span>
        </Typography>

        <Typography
          sx={styles.questionItem}
          variant="body2"
          color="text.secondary"
        >
          <ArticleIcon sx={styles.questionItemIcon} titleAccess="Total Marks" />
          <span style={styles.questionItemValue}>{totalMarks}</span>{" "}
          <span style={styles.questionItemLabel}>Total Marks</span>
        </Typography>
        <Typography
          sx={styles.questionItem}
          variant="body2"
          color="text.secondary"
        >
          <CheckCircleIcon
            sx={styles.questionItemIcon}
            titleAccess="Pass Grade"
          />
          <span style={styles.questionItemValue}>{passGrade}</span>{" "}
          <span style={styles.questionItemLabel}>Pass Gradeing</span>
        </Typography>
      </CardContent>
      <CardActions sx={styles.questionItemView}>{cardActions}</CardActions>
    </Card>
  );
};

const styles = {
  questionItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100px",
    height: "100px",
    float: "left",
    margin: "10px",
    border: "1px solid var(--mui-palette-primary-red)",
    padding: "10px",
    borderRadius: "100px",
  },
  questionItemLarge: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    float: "left",
    margin: "10px 0 20px",
  },
  questionItemIcon: {
    color: "var(--mui-palette-primary-red)",
    fontSize: "36px",
  },
  questionItemValue: {
    fontSize: "20px",
    color: "var(--mui-palette-primary-blue)",
    fontWeight: "bold",
    margin: "5px 0 0",
  },
  questionItemLabel: {
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "bold",
    color: "var(--mui-palette-primary-darkGrey)",
  },
  questionItemView: {
    position: "absolute",
    right: "45px",
    top: "6px",
  },
};
